import type { ConversationLifecycleMachineState } from "./_conversation-lifecycle-machine";
import type { UseConversationLifecycleResult } from "./_conversation-lifecycle-types";

export type LifecycleResultBase = Omit<
	UseConversationLifecycleResult,
	"phase" | "conversationId" | "error" | "response" | "optimisticUserMessage"
>;

export const buildLifecycleResult = (
	state: ConversationLifecycleMachineState,
	base: LifecycleResultBase,
	response: string | undefined,
): UseConversationLifecycleResult => {
	switch (state.phase) {
		case "idle":
		case "creating":
			return {
				...base,
				phase: state.phase,
				conversationId: undefined,
				error: undefined,
				response: undefined,
				optimisticUserMessage: undefined,
			};
		case "create_failed":
			return {
				...base,
				phase: state.phase,
				conversationId: undefined,
				error: state.error,
				response: undefined,
				optimisticUserMessage: undefined,
			};
		case "polling":
			return {
				...base,
				phase: state.phase,
				conversationId: state.conversationId,
				error: undefined,
				response: undefined,
				optimisticUserMessage: undefined,
			};
		case "complete":
			return {
				...base,
				phase: state.phase,
				conversationId: state.conversationId,
				error: undefined,
				response,
				optimisticUserMessage: undefined,
			};
		case "error":
			return {
				...base,
				phase: state.phase,
				conversationId: state.conversationId,
				error: state.error,
				response: undefined,
				optimisticUserMessage: undefined,
			};
		case "submitting":
			return {
				...base,
				phase: state.phase,
				conversationId: state.conversationId,
				error: undefined,
				response: undefined,
				optimisticUserMessage: state.optimisticUserMessage,
			};
		case "cancelled":
			return {
				...base,
				phase: state.phase,
				conversationId: state.conversationId,
				error: undefined,
				response: undefined,
				optimisticUserMessage: undefined,
			};
		case "send_failed":
			return {
				...base,
				phase: state.phase,
				conversationId: state.conversationId,
				error: state.error,
				response: undefined,
				optimisticUserMessage: undefined,
			};
	}
};
